import { ConsultationToolbarSelectorTypeEnum } from '@/modules/diagnosisModule/views/form/modals/consultation/modal-toolbar/diagnosis-consultation-modal-toolbar.model'
import { store } from '@/store/store'

export interface DiagnosisConsultationModalState {
    selectorType: ConsultationToolbarSelectorTypeEnum
    laboratoryId: number
}
export const initialDiagnosisConsultationModalState =
    (): DiagnosisConsultationModalState => ({
        selectorType: ConsultationToolbarSelectorTypeEnum.ALL_CONSULTATIONS,
        laboratoryId: store.getters.labId
    })
